import React, { useEffect } from 'react';
import './SuccessPopup.css';

function SuccessPopup({ message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2500); // Auto close after 2.5 seconds
    
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="SuccessPopup_overlay">
      <div className="SuccessPopup_content">
        <div className="SuccessPopup_icon">
          <svg className="SuccessPopup_checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="SuccessPopup_checkmark_circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="SuccessPopup_checkmark_check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        <h3 className="SuccessPopup_title">Success!</h3>
        <p className="SuccessPopup_message">{message}</p>
      </div>
    </div>
  );
}

export default SuccessPopup;
